/**
 * Typed env helper: returns the value or throws in development.
 * Use for required env vars to avoid unchecked `process.env.X as string` casts.
 */
export function requireEnv(value: string | undefined, key: string): string {
	if (value === undefined || value === '') {
		if (process.env.NODE_ENV === 'development') {
			throw new Error(`Missing required env: ${key}`);
		}
		return '';
	}
	return value;
}

/**
 * An optional env var, or '' when it is not set. The bundler (EnvironmentPlugin) only replaces `process.env.X`
 * for variables that existed at build time, and the browser has no `process`: a bare read of a missing variable
 * throws a ReferenceError. Pass the read as a function so the literal `process.env.X` stays in place for the
 * replacement and the throw is caught.
 *
 * @example readEnv(() => process.env.GOOGLE_SEARCH_API_KEY)
 */
export function readEnv(read: () => string | undefined): string {
	try {
		return read() ?? '';
	} catch {
		return '';
	}
}
